import { TicketWidgetItemArray } from '../../../models/domain/ticket.widget.item';
import { ssApiService } from '../../../services/ss-api.service';
import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { DialogService } from '../../../services/modal-dialogs';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../../services/global.service';
import { IBaseResponse } from '../../../models/comm-http/responses/BaseResponse';
import { TicketAddDialog } from '../../../dialogs/ticket.add/ticket.add.dialog';
import { CustomTicketItemArray } from '../../../models/domain/custom.ticket.item';
import { TicketAddWindowData } from '../../../../app/dialog-windows/ticket.add/ticket.add.window';
import { WindowSettings } from '../../../../app/services/window-dialogs/window.settings';

@Component({
    selector: 'member-tickets',
    templateUrl: './member.tickets.component.html',
    styleUrls: ['./member.tickets.component.css']
})
export class MemberTicketsComponent implements OnInit, OnDestroy {

    @Input('IsBusy') IsBusy: boolean = false;
    @Input('MemberID') MemberID: number = 0;
    @Input('TicketWidgets') TicketWidgets: CustomTicketItemArray;
    @Output('onRefresh') onRefresh: EventEmitter<string> = new EventEmitter();

    isListView: boolean = false;

    private subscriptions = new Array<Subscription>();
    constructor(private api: ssApiService, private gb: GlobalService, private dialogService: DialogService ) { }


    ngOnInit() {
        this.SubscribeEvents();
        this.SetListViewStyles();
    }

    ngOnDestroy() {
        this.UnsubscribeEvents();
    }

    UnsubscribeEvents() {
        if (this.subscriptions != null)
            this.subscriptions.forEach((s) => { s.unsubscribe() })

    }

    SubscribeEvents() {
        let apiEvent = this.api.onTicketsMemberWidgetsData.subscribe((args: IBaseResponse<TicketWidgetItemArray>) => {
            return true;
        })
        this.subscriptions.push(apiEvent);
    }

    public LoadTickets() {
        this.onRefresh.emit('');
    }

    async addMemberTicket() {

        let windowSettings = new WindowSettings();
        windowSettings.Height = 900;
        windowSettings.Width = 1240;

        let MemberOptions = [];
        MemberOptions.push({ label: 'None', value: 0 });
        let ticketWindowData = new TicketAddWindowData;

        await this.api.AdminBrowseLogs(this.gb.AdminHistoryMaxResults).subscribe(response => {
            // disposable.unsubscribe();

            response.Data.forEach(x => {
                if (x.MemberID != null && x.MemberID != undefined) {
                    MemberOptions.push({ label: x.MemberName, value: x.MemberID });
                }
            });

            let disposable = this.dialogService.addDialog(TicketAddDialog, {
                SelectedMemberID: this.MemberID,
                MemberOptions: MemberOptions
            }, { height: 850, width: 1100 }).subscribe(response => {
                disposable.unsubscribe();
            })

        });

    }

    SetMemberTicketListStyle(newIsListView: boolean) {
        this.isListView = newIsListView;
        localStorage.setItem('crm_MemberTicketsListView', JSON.stringify(this.isListView));
    }


    SetListViewStyles() {
        this.isListView = JSON.parse(localStorage.getItem('crm_MemberTicketsListView'));
    }

}
